import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import BaseButton from '~/utils/base/BaseButton';
let ButtonShareLink = class ButtonShareLink extends BaseButton {
};
ButtonShareLink = __decorate([
    Component
], ButtonShareLink);
export default ButtonShareLink;
